/**
 * Raw, unvalidated analytics adapter mode from the environment.
 * Validation + defaults live in `createAnalyticsAdapterFromEnv.ts`.
 */
export const ENV_ANALYTICS_ADAPTER = import.meta.env.VITE_ANALYTICS_ADAPTER
